<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      stroke-opacity="0"
      d="m11.5 10.6665 1.2473 1.42548L11.5 13.51746l-1.2473-1.42548z"
    />
    <path
      fill-opacity="0"
      d="M0 .75258h4.31507v4.31507H0z"
      transform="scale(.93127 1.0643) rotate(45 -2.84411 19.39448)"
    />
    <path fill-opacity="0" stroke-width="2" d="M5 4h13v16H5z" />
    <path
      d="M4.5 2v1M6.5 2v1M8.5 2v1M10.5 2v1M12.5 2v1M14.5 2v1M16.5 2v1M18.5 2v1M4.5 21v1M6.5 21v1M8.5 21v1M12.5 21v1M18.5 21v1M16.5 21v1M14.5 21v1M10.5 21v1"
    />
  </svg>
</template>
